<div id="toolbarSidebar">
  <div class="splitToolbarButton toggled">
    <button type="button" id="viewThumbnail" class="toolbarButton toggled" title="Show Thumbnails" data-l10n-id="thumbs">
      <span data-l10n-id="thumbs_label">Thumbnails</span>
    </button>

    <button
      type="button"
      id="viewOutline"
      class="toolbarButton"
      title="Show Document Outline (double-click to expand/collapse all items)"
      data-l10n-id="document_outline">
      <span data-l10n-id="document_outline_label">Document Outline</span>
    </button>

    <button type="button" id="viewAttachments" class="toolbarButton" title="Show Attachments" data-l10n-id="attachments">
      <span data-l10n-id="attachments_label">Attachments</span>
    </button>
  </div>
</div>
